// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"5921ab3b","511":"5921ab3b"}[chunkId] + ".chunk.css";
};